"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Microphone = function Microphone(props) {
  return _react2["default"].createElement("svg", (0, _extends3["default"])({
    width: 11,
    height: 16,
    viewBox: "0 0 11 16"
  }, props), _react2["default"].createElement("title", null, "917D8EF9-8891-4D9A-A719-035B45E15E04"), _react2["default"].createElement("path", {
    d: "M4.813 14.667v-1.375C2.099 12.964 0 10.72 0 8V6.667C0 6.298.308 6 .688 6c.38 0 .687.298.687.667V8c0 2.21 1.847 4 4.125 4s4.125-1.79 4.125-4V6.667c0-.369.308-.667.688-.667.38 0 .687.298.687.667V8c0 2.72-2.1 4.964-4.813 5.292v1.375H8.25c.38 0 .688.298.688.666A.677.677 0 0 1 8.25 16h-5.5a.677.677 0 0 1-.688-.667c0-.368.308-.666.688-.666h2.063zM5.5 0c1.519 0 2.75 1.194 2.75 2.667V8c0 1.473-1.231 2.667-2.75 2.667S2.75 9.473 2.75 8V2.667C2.75 1.194 3.981 0 5.5 0z",
    className: "fill"
  }));
};

exports["default"] = Microphone;